import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import AccountDropPanel from 'Components/AccountDropPanel';
import MenuAccount from './MenuAccount';
import { toggleSideMenu } from 'Store/actions';
import { connect } from 'react-redux';

class UserProfile extends Component {
  static propTypes = {
    auth: PropTypes.object,
    drawer: PropTypes.object,
    tribun: PropTypes.object,
    loginUser: PropTypes.func,
    logoutUser: PropTypes.func,
    openModal: PropTypes.func,
    getUserTribunToken: PropTypes.func,
    platform: PropTypes.string,
    device: PropTypes.object,
    helmet: PropTypes.object,
    unreadAnnouncementsCount: PropTypes.number,
    isMenuOpen: PropTypes.bool,
    countOpen: PropTypes.number,
    toggleSideMenu: PropTypes.func,
    dontRequest: PropTypes.bool,
  };

  constructor (props) {
    super(props);

    this.state = {
      isMenuOpenState: false,
      countCancel: 0
    };
  }

  toggleMenu = () => {
    this.setState(prevState => ({
      isMenuOpenState: !prevState.isMenuOpenState
    }));
  };

  closeMenu = () => {
    this.setState({
      countCancel: this.state.countCancel + 1
    });
    this.props.toggleSideMenu();
  };

  render () {
    // const { countCancel } = this.state;
    const { auth, platform, device, helmet, tribun, getUserTribunToken, openModal, unreadAnnouncementsCount, drawer } = this.props;
    // const isMenuOpen =  countOpen > countCancel;
    const isMenuOpen = drawer.sideMenuOpen;
    const bodyClass = helmet.bodyAttributes.class;


    const accountMenuTemplate = (
      <AccountDropPanel onClose={ this.closeMenu } isOpen={ isMenuOpen }>
        { isMenuOpen ? (
          <Helmet>
            <body className={ `${bodyClass} side-menu-open` } />
          </Helmet>
        ) : null }
        <MenuAccount
          auth={ auth }
          unreadAnnouncementsCount={ unreadAnnouncementsCount }
          platform={ platform }
          device={ device }
          tribun={ tribun }
          getUserTribunToken={ getUserTribunToken }
          openModal={ openModal }
          isMenuOpen={ isMenuOpen }
          dontRequest={ this.props.dontRequest }
        />
      </AccountDropPanel>
    );

    return (
      <>
        { accountMenuTemplate }
      </>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  drawer: state.drawer
});

export default connect(
  mapStateToProps,
  { toggleSideMenu }
)(UserProfile);
